import { useDesignSystem } from 'contexts/design-system'
import SearchBarEui from './searchBar.eui'
import SearchBarMui from './searchBar.mui'
import { SearchBarProps } from './types'

export type { SearchBarProps } from './types'

export default function SearchBar( props: SearchBarProps ): React.ReactElement | null {
	return useDesignSystem() === 'mui'
		? <SearchBarMui {...props} />
		: <SearchBarEui {...props} />
}
